export enum FleetVehicleFieldStatus {
	REQUIRED = 'REQUIRED', // field is mandatory & missing
	MISSING = 'MISSING', // field is optional & missing
	ERROR = 'ERROR' // field has error
}
